module.exports = __webpack_public_path__ + "static/media/mute.130e5a78.png";